import React from 'react'
import { useNavigate } from 'react-router-dom'

export const Footer = () => {
    const navigate = useNavigate();
    return (
        <footer className="footer-part">
            <div className="container">
                <div className="row">
                    <div className="col-sm-6 col-xl-3">
                        <div className="footer-widget">
                            <a className="footer-logo" href="#">
                                <img src={require("../assets/images/logo.png")} alt="logo" />
                            </a>
                            <p className="footer-desc">Welcome to ASM Wedding Cards, where your wedding dreams are brought to
                                life with creativity, elegance, and care. we have 15 Years of experience this field.</p>
                            <ul className="footer-social">
                                <li><a target="_blank" className="icofont-facebook"
                                    href="https://www.facebook.com/people/ASM-Wedding-Cards/100068361073559/?mibextid=ZbWKwL"></a>
                                </li>
                                <li><a className="icofont-instagram" target="_blank" href="https://www.instagram.com/asmweddingcards/"></a></li>
                                <li>
                                    <a target="_blank" href="https://www.youtube.com/@asmgraphics5965"
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <i className="fab fa-youtube"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xl-3">
                        <div className="footer-widget contact">
                            <h3 className="footer-title">contact us</h3>
                            <ul className="footer-contact">
                                <li>
                                    <i className="icofont-ui-email"></i>
                                    <p>
                                        <span>asm.manivannan@gmail.com</span>
                                        <span>info@asmweddingcards.com</span>
                                    </p>
                                </li>
                                <li>
                                    <i className="icofont-ui-touch-phone"></i>
                                    <p>
                                        <span>+91 9865230900</span>
                                        <span>+91 8838569796</span>
                                    </p>
                                </li>
                                <li>
                                    <i className="icofont-location-pin"></i>
                                    <p>75, Thammampatti Main Road, Vazhapadi, Salem District, Tamil Nadu 636115</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xl-3">
                        <div className="footer-widget">
                            <h3 className="footer-title">quick Links</h3>
                            <div className="footer-links">
                                <ul>
                                    <li><a onClick={() => navigate('/')} style={{cursor:'pointer'}}>Home</a></li>
                                    <li><a onClick={() => navigate('/about')} style={{cursor:'pointer'}}>About Us</a></li>
                                    <li><a onClick={() => navigate('/cards')} style={{cursor:'pointer'}}>Cards</a></li>
                                    <li><a onClick={() => navigate('/weddingwebsite')} style={{cursor:'pointer'}}>Wedding Website</a></li>
                                    <li><a onClick={() => navigate('/contact')} style={{cursor:'pointer'}}>Contact Us</a></li>
                                </ul>

                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-xl-3">
                        <div className="footer-widget">
                            <h3 className="footer-title">Location</h3>
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3907.4908551765116!2d78.3339434!3d11.659584299999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bab8d743f0ab663%3A0xb3425b23bb8d87a0!2sAmy%20technologies%20Corporate%20office!5e0!3m2!1sen!2sin!4v1778222686295!5m2!1sen!2sin" width="600" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3907.5898081808123!2d78.39905937395753!3d11.652550842425141!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bab8e1cfad60e0f%3A0x8f58578f3c92bf4!2sASM%20Graphics%20%26%20Printers%20%2C%20ASM%20Wedding%20Card!5e0!3m2!1sen!2sin!4v1717826147265!5m2!1sen!2sin" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            {/* <p className="footer-desc">Looking for wedding cards in Salem? ASM Wedding Cards offers 2000+
                                designs, custom printing, and premium invitations at affordable prices. Downlaod the App
                                today!</p>
                            <div className="footer-app">
                                <a href="#"><img src={require("../assets/images/google-store.png")} alt="google" /></a>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="footer-bottom">
                            <p className="footer-copytext">&copy; All Copyrights Reserved by <a target="_blank" href="#">ASM
                                Wedding cards</a></p>
                            <div className="footer-card">
                                <p className="footer-copytext">Developed by <a target="_blank"
                                    href="https://amytechnologies.in/">AMY Technologies</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
